import FormTools from '../utils/formTools';

window.FormTools = new FormTools();

$(() => {	
	window.FormTools.init();
});